// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__2Qre4","text":"style_text__3Z4vL"};